<template>
  <article class="layout-section -align-side">
    <figure class="layout-section__figure" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.history.title }}</h2>
      <p>
        {{ wp.history.text }}
      </p>

      <RouterLink :to="{ name: 'about-history' }" class="button layout-section__cta">
        Explorez notre histoire
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutHistory',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.history.image})`
    }
  }
}
</script>
